import React, { useEffect, useRef, useState } from 'react';
import { Trash2, Upload, X } from 'lucide-react';
import api from '../../api/client';
import InFinestra from '../../components/InFinestra';

// Archivio immagini dei prodotti: ogni immagine caricata resta qui e si può riusare.
// modo 'scegli' = clic su un'immagine la mette nel prodotto aperto; 'gestisci' = vedi, carica, elimina.
export default function ArchivioImmagini({ modo, puoCaricare, puoEliminare, apiBase, onChiudi, onScegli, scelte = [] }) {
  const [imgs, setImgs] = useState(null);
  const [cerca, setCerca] = useState('');
  const [errore, setErrore] = useState('');
  const [caricando, setCaricando] = useState(null); // null | { fatte, totale }
  const [esito, setEsito] = useState('');
  const fileRef = useRef();

  const carica = () => api.get('/products/immagini').then(r => setImgs(r.data)).catch(e => { setImgs([]); setErrore(e.response?.data?.error || 'Errore'); });
  useEffect(() => { carica(); }, []);

  const leggi = (file) => new Promise((ok, ko) => {
    const r = new FileReader();
    r.onload = ev => ok(ev.target.result); r.onerror = () => ko(new Error('file non leggibile'));
    r.readAsDataURL(file);
  });

  // Più foto insieme: una alla volta verso il server, chi fallisce non ferma le altre.
  const nuove = async (e) => {
    const files = [...e.target.files]; e.target.value = ''; if (!files.length) return;
    setErrore(''); setEsito('');
    const falliti = [];
    for (let k = 0; k < files.length; k++) {
      setCaricando({ fatte: k, totale: files.length });
      const f = files[k];
      try {
        if (f.size > 8 * 1024 * 1024) throw new Error('più di 8 MB');
        await api.post('/products/immagini', { imageBase64: await leggi(f), nome: f.name.replace(/\.[^.]+$/, '') });
      } catch (err) { falliti.push(`${f.name}: ${err.response?.data?.error || err.message}`); }
    }
    setCaricando(null);
    const ok = files.length - falliti.length;
    setEsito(`${ok} ${ok === 1 ? 'immagine caricata' : 'immagini caricate'}${falliti.length ? `, ${falliti.length} non caricate` : ''}.`);
    if (falliti.length) setErrore(falliti.join(' · '));
    carica();
  };

  const elimina = async (img) => {
    if (!window.confirm(`Eliminare per sempre "${img.nome}" dall'archivio?`)) return;
    setErrore('');
    try { await api.delete(`/products/immagini/${img.id}`); carica(); }
    catch (err) { setErrore(err.response?.data?.error || 'Errore eliminazione'); }
  };

  const visibili = (imgs || []).filter(i => !cerca || `${i.nome} ${i.usata_da.map(p => p.nome).join(' ')}`.toLowerCase().includes(cerca.toLowerCase()));

  return (
    <InFinestra attiva onChiudi={onChiudi} larghezza={900}>
      <div style={{ padding: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 800, fontSize: 'var(--font-size-lg)', letterSpacing: '1px' }}>ARCHIVIO IMMAGINI</div>
            <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-dim)' }}>
              {modo === 'scegli' ? `Tocca le foto da mettere nel prodotto (di nuovo per toglierle). Scelte: ${scelte.length}.` : 'Ogni immagine caricata resta qui, anche se elimini il prodotto o gli cambi immagine.'}
            </div>
          </div>
          {modo === 'scegli' && <button onClick={onChiudi} style={{ padding: '8px 14px', borderRadius: '10px', border: 'none', background: 'var(--accent-strong,#C24B08)', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>FATTO</button>}
          <button onClick={onChiudi} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text)' }}><X size={18} /></button>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
          <input placeholder="Cerca per nome o prodotto…" value={cerca} onChange={e => setCerca(e.target.value)}
            style={{ flex: 1, minWidth: '180px', padding: '9px 12px', borderRadius: '10px', border: '1px solid var(--border2)', background: 'var(--bg-input)', color: 'var(--text)' }} />
          {puoCaricare && <>
            <button disabled={!!caricando} onClick={() => fileRef.current.click()}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 14px', borderRadius: '10px', border: 'none', background: 'var(--accent-strong,#C24B08)', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
              <Upload size={14} /> {caricando ? `CARICO ${caricando.fatte + 1} DI ${caricando.totale}…` : 'CARICA IMMAGINI'}
            </button>
            <input ref={fileRef} type="file" multiple accept="image/jpeg,image/png,image/webp,image/gif" style={{ display: 'none' }} onChange={nuove} />
          </>}
        </div>
        {puoCaricare && !esito && !errore && <div style={{ color: 'var(--text-dim)', fontSize: 'var(--font-size-xs)', marginBottom: '10px' }}>Puoi selezionare più foto insieme (JPG, PNG, WebP, GIF, max 8 MB l'una). Ognuna tiene il nome del suo file.</div>}
        {esito && <div style={{ color: '#22C55E', fontSize: 'var(--font-size-xs)', marginBottom: '6px', fontWeight: 700 }}>{esito}</div>}
        {errore && <div style={{ color: '#EF4444', fontSize: 'var(--font-size-xs)', marginBottom: '10px' }}>{errore}</div>}
        {imgs === null ? <div style={{ color: 'var(--text-dim)' }}>Caricamento…</div>
          : visibili.length === 0 ? <div style={{ color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)' }}>Nessuna immagine.</div>
          : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '12px' }}>
            {visibili.map(img => (
              <div key={img.id} onClick={() => modo === 'scegli' && onScegli(img)}
                style={{ border: scelte.includes(img.id) ? '3px solid #F4600C' : '1px solid var(--border)', borderRadius: '12px', overflow: 'hidden', background: 'var(--bg-card)', cursor: modo === 'scegli' ? 'pointer' : 'default', position: 'relative' }}>
                {scelte.includes(img.id) && <div style={{ position: 'absolute', top: '6px', right: '6px', background: '#F4600C', color: '#fff', borderRadius: '999px', minWidth: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 800 }}>{scelte.indexOf(img.id) + 1}</div>}
                <div style={{ height: '120px', background: 'var(--bg-input)' }}>
                  <img src={`${apiBase}${img.url}`} alt="" loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ padding: '8px', fontSize: '12px' }}>
                  <div style={{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={img.nome}>{img.nome}</div>
                  <div style={{ color: 'var(--text-dim)', marginTop: '2px' }}>
                    {img.usata_da.length ? `Su: ${img.usata_da.map(p => p.nome + (p.attivo ? '' : ' (disattivato)')).join(', ')}` : 'Non usata'}
                  </div>
                  {modo === 'gestisci' && puoEliminare && img.usata_da.length === 0 && (
                    <button onClick={() => elimina(img)} title="Elimina dall'archivio"
                      style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px', background: 'none', border: '1px solid var(--border2)', borderRadius: '8px', padding: '4px 8px', color: '#EF4444', cursor: 'pointer', fontSize: '11px', fontWeight: 700 }}>
                      <Trash2 size={12} /> ELIMINA
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </InFinestra>
  );
}
